import script from "./AccessUv.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccessUv.vue?vue&type=script&setup=true&lang=ts"

import "./AccessUv.vue?vue&type=style&index=0&id=c32f45f4&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/运营辅助平台正式前端/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c32f45f4"]])

export default __exports__